/**
 * Development Councils Translations (Portuguese)
 * @module developmentCouncils
 * @language pt
 */

export const developmentCouncils = {
  developmentCouncils: {
    title: "Conselhos de Desenvolvimento da JCI",
    subtitle: "Quatro Pilares Regionais para Crescimento & Desenvolvimento",
    description: "Os Conselhos de Desenvolvimento de Área da JCI trabalham junto ao Conselho de Diretores da JCI e à Sede da JCI para servir como pilares regionais para o desenvolvimento de liderança, crescimento organizacional e impacto sustentável em todo o mundo.",

    heroBadge: "Expansão Global da JCI",
    networkGrowthBadge: "Crescimento da Rede JCI",

    overview: {
      title: "Visão Global",
      description: "Estes conselhos representam as divisões geográficas estratégicas da JCI, trabalhando juntos para desenvolver líderes para um mundo em mudança.",
      councilsCount: "4 Conselhos de Área",
      regionsServed: "Todos os Continentes"
    },

    sections: {
      mission: "Missão",
      strategicGoals: "Objetivos Estratégicos 2025",
      keyAchievements: "Conquistas Principais",
      keyMetrics: "Métricas Principais",
      recommendations: "Recomendações 2026",
      highlights: "Destaques 2025"
    },

    councils: {
      adc: {
        name: "Conselho de Desenvolvimento Americano",
        abbreviation: "ADC",
        region: "América",
        mission: "Mostrar ações que aumentem a visibilidade da marca JCI, impulsionem o crescimento e retenção de membros, e proporcionem experiências de liderança de desenvolvimento global aos membros.",
        goals: {
          brandAwareness: {
            name: "Consciência de Marca e Visibilidade",
            description: "Aumentar o engajamento em plataformas de redes sociais e promover as atividades da JCI.",
            achievements: [
              "30% de aumento no engajamento em redes sociais",
              "2 artigos publicados na JCI Lead Magazine",
              "Tags estratégicas e interações melhoradas"
            ]
          },
          leadershipDevelopment: {
            name: "Desenvolvimento de Liderança",
            description: "Treinar e desenvolver novos líderes em toda a região das Américas.",
            achievements: [
              "Reunião de Presidentes Nacionais com 68% de participação (17 Presidentes)",
              "Academia de Liderança Americana 25° aniversário com 77% de participação",
              "27 novos líderes treinados com mais de 30 horas de conteúdo",
              "Programa de Treinamento de Liderança com 8 sessões"
            ]
          },
          sustainableStructure: {
            name: "Estrutura Aberta, Eficiente e Sustentável",
            description: "Apoiar o desenvolvimento e expansão de Organizações Nacionais.",
            achievements: [
              "Chile apresentado como Organização Potencial da JCI",
              "Guatemala apoiada para status Provisório",
              "Conferência de Clube Júnior com 250 inscrições"
            ]
          }
        },
        metrics: {
          socialMedia: { label: "Crescimento em Redes Sociais", value: "30%" },
          membership: { label: "Meta de Associação", value: "5%" },
          bestPractices: { label: "Pesquisa de Melhores Práticas", value: "834" },
          leadersTrained: { label: "Líderes Treinados", value: "27" }
        },
        highlights: [
          "Academia de Liderança Americana celebrou 25° aniversário",
          "Primeiro Evento Global Online sobre Compartilhar Melhores Práticas",
          "Lançamento da Conferência de Clube Júnior com liderança ADC"
        ]
      },
      edc: {
        name: "Conselho de Desenvolvimento Europeu",
        abbreviation: "EDC",
        region: "Europa",
        mission: "Fomentar uma cultura que apoie o crescimento, inovação e colaboração entre Organizações Nacionais em 41 regiões da Europa.",
        goals: {
          valueProposition: {
            name: "Proposta de Valor",
            description: "Criar campanhas trimestrais de redes sociais direcionadas ao grupo demográfico de 18-40 anos.",
            achievements: [
              "+8.896 novos seguidores de janeiro a novembro",
              "9.789 publicações realizadas",
              "5.176 compartilhamentos alcançados"
            ]
          },
          geographicExpansion: {
            name: "Expansão Geográfica",
            description: "Estabelecer presença da JCI em novas regiões.",
            achievements: [
              "Meta: 3 novas regiões geográficas até Q3",
              "Apoiando novas organizações potenciais",
              "Expandindo dentro de Organizações Nacionais existentes"
            ]
          },
          knowledgeSharing: {
            name: "Compartilhamento de Conhecimento",
            description: "Organizar programas que permitam colaboração cruzada.",
            achievements: [
              "4 programas de compartilhamento de conhecimento organizados",
              "Programa de mentoria renovado com colaboração ASE",
              "24 equipes de mentorados inscritas"
            ]
          },
          productDevelopment: {
            name: "Desenvolvimento de Novos Produtos",
            description: "Lançar ferramentas para desenvolver capítulos locais sustentáveis.",
            achievements: [
              "JCI Serious Game desenvolvido e testado",
              "7 países participaram de testes de protótipo",
              "Pontuação média de satisfação de 4,5/5"
            ]
          }
        },
        metrics: {
          followers: { label: "Novos Seguidores", value: "+8.896" },
          academyParticipants: { label: "Participantes da Academia", value: "158+" },
          gameSatisfaction: { label: "Satisfação do Jogo", value: "4,5/5" },
          regionsCovered: { label: "Regiões Cobertas", value: "41" }
        },
        highlights: [
          "Protótipo do JCI Serious Game testado em 7 países",
          "Academia de Liderança Mediterrânea (31 participantes)",
          "Academia Europeia na Suécia (99 participantes)",
          "Academia Tri Nações (Irlanda, Reino Unido, Escócia)",
          "Academia Balcânica (7 países, 14 participantes)"
        ]
      },
      amdec: {
        name: "Conselho de Desenvolvimento da África e Oriente Médio",
        abbreviation: "AMDEC",
        region: "África e o Oriente Médio",
        mission: "Empoderar jovens líderes empreendedores na África e Oriente Médio para impulsionar mudanças positivas através do desenvolvimento de liderança, parcerias estratégicas e soluções inovadoras.",
        goals: {
          anniversary: {
            name: "Celebrações do 40° Aniversário",
            description: "Marcar quatro décadas de impacto e liderança em toda a região.",
            achievements: [
              "Campanha digital 40 Anos de Impacto lançada",
              "Cerimônias de reconhecimento para líderes passados e atuais",
              "Iniciativas lançadas para sustentar o legado do AMDEC"
            ]
          },
          skillsDevelopment: {
            name: "Treinamento e Desenvolvimento de Habilidades",
            description: "Implementar treinamentos mensais em áreas operacionais chave.",
            achievements: [
              "Treinamento em Gestão Financeira e Orçamentos",
              "Reuniões Eficazes e Procedimentos Parlamentares",
              "Gestão de Projetos e Avaliação de Impacto",
              "Marca Pessoal e Desenvolvimento de Liderança"
            ]
          },
          strategicCollaboration: {
            name: "Colaboração Estratégica",
            description: "Superar barreiras linguísticas e fomentar colaboração regional.",
            achievements: [
              "Série JCI Lusófona lançada para países de língua portuguesa",
              "Conferência de Clube Júnior com 100+ participantes online",
              "Série de Jogos JCI em parceria com EDC e JCI França"
            ]
          }
        },
        metrics: {
          yearsOfImpact: { label: "Anos de Impacto", value: "40" },
          newMarkets: { label: "Novos Mercados", value: "2" },
          conferenceAttendees: { label: "Participantes da Conferência", value: "100+" },
          trainingTopics: { label: "Tópicos de Treinamento", value: "4+" }
        },
        highlights: [
          "Celebrações do 40° Aniversário em toda a região",
          "Reunião de Presidentes Nacionais em Maurício",
          "27ª Academia JCI África e Oriente Médio",
          "Série JCI Lusófona conectando nações de língua portuguesa",
          "Quênia completou marco de registro governamental"
        ]
      },
      apdc: {
        name: "Conselho de Desenvolvimento Ásia-Pacífico",
        abbreviation: "APDC",
        region: "Ásia e o Pacífico",
        mission: "Expandir a presença da JCI e atuar como um fator positivo no desenvolvimento regional através da missão da JCI.",
        goals: {
          strategicPlan: {
            name: "Execução do Plano Estratégico",
            description: "Compartilhar e executar o Framework de Ação da JCI e o Plano Estratégico 2023-2027.",
            achievements: [
              "12 missões realizadas a países-alvo",
              "Colaboração com outros Conselhos de Desenvolvimento",
              "Plano estruturado através de reuniões trimestrais"
            ]
          },
          countryEmpowerment: {
            name: "Empoderamento de Países",
            description: "Empoderar os países designados rumo à afiliação ou graduação.",
            achievements: [
              "6 novas Organizações Locais afiliadas",
              "1 Organização Nacional declarada",
              "356+ membros recrutados",
              "Bases sustentáveis em administração e finanças"
            ]
          },
          countryDevelopment: {
            name: "Desenvolvimento Específico por País",
            description: "Programas de desenvolvimento direcionados para cada país.",
            achievements: [
              "Tailândia: 20% de crescimento de associação (150→180)",
              "Mianmar: Arrecadação de 11.000 USD para Ajuda a Terremoto",
              "Sri Lanka: Primeira Convenção Nacional após renascimento",
              "Uzbequistão: Crescimento de 46 para 60 membros"
            ]
          }
        },
        metrics: {
          membersRecruited: { label: "Membros Recrutados", value: "356+" },
          newLocalOrgs: { label: "Novas Orgs Locais", value: "6" },
          missionsConducted: { label: "Missões Realizadas", value: "12" },
          nationalOrgs: { label: "Orgs Nacionais", value: "1" }
        },
        highlights: [
          "JCI Tailândia alcançou 85% no Índice de Desempenho de Sustentabilidade",
          "Projeto de Ajuda a Terremoto de Mianmar ajudou 500+ indivíduos",
          "Sri Lanka realizou primeira Convenção Nacional",
          "Timor-Leste conectou-se com 9 organizações parceiras",
          "Desenvolvimento de Laos iniciado com parceria YEAL"
        ]
      }
    },

    comparativeAnalysis: {
      title: "Análise Comparativa",
      subtitle: "Como os quatro conselhos se comparam em dimensões-chave",
      categories: {
        geographicCoverage: {
          name: "Cobertura Geográfica",
          adc: "América Central e do Sul, Caribe, América do Norte",
          edc: "41 regiões, concentradas em centros universitários",
          amdec: "40+ anos de presença regional",
          apdc: "Mianmar, Tailândia, Sri Lanka, Timor-Leste, Uzbequistão, Laos"
        },
        strategicPriorities: {
          name: "Prioridades Estratégicas",
          adc: "Visibilidade de marca através de redes sociais, metas de crescimento de associação",
          edc: "Expansão geográfica, compartilhamento de conhecimento, produtos inovadores",
          amdec: "Legado institucional, estruturas fundamentais, novos mercados",
          apdc: "Empoderamento de países, missões direcionadas, construção de capacidades"
        },
        leadershipDevelopment: {
          name: "Desenvolvimento de Liderança",
          adc: "Reuniões de Presidentes Nacionais, Academia de Liderança Americana",
          edc: "Academias regionais, programas de mentoria, jogos sérios",
          amdec: "Academias de Liderança, treinamentos mensais, mentoria",
          apdc: "Missões específicas por país, workshops especializados"
        }
      }
    },

    keyHighlights: {
      title: "Destaques 2025",
      subtitle: "Principais conquistas e inovações de todos os conselhos",
      items: {
        seriousGame: {
          title: "JCI Serious Game",
          description: "Ferramenta de aprendizagem interativa desenvolvida pelo EDC, testada em 7 países com classificação de satisfação de 4,5/5."
        },
        juniorClub: {
          title: "Conferência de Clube Júnior",
          description: "Iniciativa entre conselhos com 250+ inscrições, inspirando jovens aspirantes a JCI."
        },
        anniversary: {
          title: "40° Aniversário do AMDEC",
          description: "Quatro décadas de impacto celebradas com campanhas digitais e cerimônias de reconhecimento."
        },
        apdcGrowth: {
          title: "Marco de Crescimento do APDC",
          description: "356+ membros recrutados, 6 novas Organizações Locais afiliadas, 12 missões estratégicas realizadas."
        },
        lusophoneSeries: {
          title: "Série JCI Lusófona",
          description: "Conectando países de língua portuguesa incluindo Angola, Cabo Verde, Guiné-Bissau e mais."
        }
      }
    },

    newNationalOrganizations: {
      title: "Novas Organizações Nacionais",
      subtitle: "Expandindo nossa rede global com comunidades JCI emergentes",
      potential: {
        title: "Potencial",
        description: "Explorando afiliação à JCI e estabelecendo estruturas fundamentais"
      },
      provisional: {
        title: "Provisório",
        description: "Construindo associação e cumprindo padrões JCI para afiliação plena"
      },
      fullAffiliation: {
        title: "Afiliação Plena",
        description: "Recentemente alcançou status de membro pleno na rede global JCI"
      },
      countries: {
        angola: "JCI Angola",
        djibouti: "JCI Djibuti",
        chile: "JCI Chile",
        gambia: "JCI Gâmbia",
        sriLanka: "JCI Sri Lanka",
        portugal: "JCI Portugal",
        myanmar: "JCI Mianmar",
        armenia: "JCI Armênia"
      }
    },

    chairperson: "Presidente",
    learnMore: "Saiba Mais",
    viewDetails: "Ver Detalhes",
    source: "Fonte: Relatório Integral dos Conselhos de Desenvolvimento JCI 2025"
  }
} as const;
